import { Recruitment, User } from 'entities';

import { IconButton } from 'components/Blocks';
import { useRecruitmentOwnerChange } from '../hooks';
import { UserPlusIcon } from 'components/Icons';

type BaseRecruitment = Pick<Recruitment, 'status' | 'id'> & {
  owner: User;
};

interface AssignRecruitmentIconButtonProps<RecruitmentEntity extends BaseRecruitment> {
  children?: never;
  recruitment: RecruitmentEntity;
  updateRecruitment: (data: RecruitmentEntity) => void;
}

export function AssignRecruitmentIconButton<RecruitmentEntity extends BaseRecruitment>({
  recruitment,
  updateRecruitment,
}: AssignRecruitmentIconButtonProps<RecruitmentEntity>) {
  const { canChangeRecruitmentOwner, changeRecruitmentOwner, loading } = useRecruitmentOwnerChange({
    recruitment,
    onNewOwner: (owner) => updateRecruitment({ ...recruitment, owner }),
  });

  const canChange = canChangeRecruitmentOwner(recruitment);

  if (!canChange) return null;

  return (
    <IconButton size="small" onClick={changeRecruitmentOwner} loading={loading}>
      <UserPlusIcon />
    </IconButton>
  );
}
